import { FormUtility } from './../utility/formUtility.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  constructor(private http: HttpClient) { }

  getRecaptcha() {
    return this.http.get(`/PagamentiArisgan/public/api/pagamento/recaptcha`) as Observable<any>;
  }

  confermaPagamento(praticaPagamento: any) {
    const headers = new HttpHeaders();
    headers.append("Content-Type", "application/form-data");
    const dataToSend = FormUtility.toFormData(praticaPagamento);
    return this.http.post(`/PagamentiArisgan/public/api/pagamento/conferma`, dataToSend , { observe: 'response', responseType: 'blob' as 'json', headers }) as Observable<any>;
  }

  getAllProvince() {
    return this.http.get(`/PagamentiArisgan/public/api/provincia/all`, {}) as Observable<any>;
  }

  getAllProvinceRer() {
    return this.http.get(`/PagamentiArisgan/public/api/provincia/rer`, {}) as Observable<any>;
  }

  /*
    getComuniByIdProv(idProv: number) {
      return this.http.get(`/PagamentiArisgan/public/api/comune/prov/${idProv}/all`, {}) as Observable<any>;
    }

    getCapByIdComune(idComune: number) {
      return this.http.get(`/PagamentiArisgan/public/api/cap/${idComune}`, {}) as Observable<any>;
    }
   */
}
